import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from "../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit";
import ObjectsPage from "../../../../_metronic/layout/components/basePage/pages/ObjectsPage";
import { FilterObjectsUIProvider } from "../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext";
import {
  rowFormatter,
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  placColumns,
  prepareFilter,
  placeFilterFields,
  filterInitialValues,
} from "./AuditFormReportUtils";

const PlaceAuditFormReportPage = () => {
  const { currentState } = useSelector(
    (state) => ({ currentState: state.placeAuditFormReports }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find((q) => q.url == "/reportPlaces")) {
    const temp = menuList.find((q) => q.url == "/reportPlaces");
    isFullAccess = temp.isFullAccess;
  }

  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          <ContentRoute
            path="/reportPlaces"
            render={(props) => (
              <ObjectsPage
                rowFormatter={rowFormatter}
                filterByShowButton={true}
                AuditAction={false}
                haveGeneralAction={false}
                isFullAccess={isFullAccess}
                basePath="/reportPlaces"
                api="api/AuditFormResult"
                getFunctionName="GetPlacesReport"
                exportfuncName="GetExcelPlacesReport"
                currentState={currentState}
                columns={placColumns}
                prepareFilter={prepareFilter}
                filterFields={placeFilterFields}
                filterInitialValues={filterInitialValues}
                enablePagination={false}
                haveExportButton={true}
              />
            )}
          />
        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  );
};

export default PlaceAuditFormReportPage;
